<template>
  <svg :width="props.size" :height="props.size" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" style="display:block;flex-shrink:0;">
    <path
      opacity="0.4"
      d="M14.4416 12.6667L12.8499 14.2417C12.4916 14.6 11.9499 14.7167 11.4916 14.5417C10.2166 14.05 8.86657 13.1667 7.64157 11.95C6.42491 10.725 5.54157 9.37503 5.04991 8.10003C4.87491 7.6417 4.99157 7.10003 5.34991 6.7417L6.92491 5.15003C7.42491 4.65003 7.42491 3.83337 6.92491 3.33337L5.74991 2.1667C5.24991 1.6667 4.43324 1.6667 3.93324 2.1667L2.89157 3.20837C2.25824 3.8417 1.99157 4.75837 2.15824 5.6417C2.51657 7.4917 3.67491 10.3667 6.59157 13.2834C9.50824 16.2 12.3832 17.3584 14.2332 17.7167C15.1166 17.8834 16.0332 17.6167 16.6666 16.9834L17.7082 15.9417C18.2082 15.4417 18.2082 14.625 17.7082 14.125L16.5416 12.95C16.0416 12.4584 15.2416 12.4584 14.7416 12.95L14.4416 12.6667Z"
      :fill="props.primaryColor"
    />
    <path
      d="M14.4416 12.6667L12.8499 14.2417C12.4916 14.6 11.9499 14.7167 11.4916 14.5417C10.2166 14.05 8.86657 13.1667 7.64157 11.95C6.42491 10.725 5.54157 9.37503 5.04991 8.10003C4.87491 7.6417 4.99157 7.10003 5.34991 6.7417L6.92491 5.15003C7.42491 4.65003 7.42491 3.83337 6.92491 3.33337L5.74991 2.1667C5.24991 1.6667 4.43324 1.6667 3.93324 2.1667L2.89157 3.20837C2.25824 3.8417 1.99157 4.75837 2.15824 5.6417C2.51657 7.4917 3.67491 10.3667 6.59157 13.2834C9.50824 16.2 12.3832 17.3584 14.2332 17.7167C15.1166 17.8834 16.0332 17.6167 16.6666 16.9834L17.7082 15.9417C18.2082 15.4417 18.2082 14.625 17.7082 14.125L16.5416 12.95C16.0416 12.4584 15.2416 12.4584 14.7416 12.95L14.4416 12.6667Z"
      :stroke="props.primaryColor"
      stroke-width="0.4"
    />
    <path
      d="M11.5167 4.73311C12.85 5.02477 13.8917 6.06644 14.1834 7.39977"
      :stroke="props.primaryColor"
      stroke-width="1.25"
      stroke-linecap="round"
    />
    <path
      d="M11.5167 2.5C14.0584 2.825 16.075 4.84167 16.4 7.38333"
      :stroke="props.primaryColor"
      stroke-width="1.25"
      stroke-linecap="round"
    />
  </svg>
</template>

<script setup>
/* global defineProps */
const props = defineProps({
  primaryColor: {
    type: String,
    default: '#3C67D6'
  },
  size: {
    type: [Number, String],
    default: 20
  }
})

</script>
